import { useState, useEffect } from 'react';

/**
 * Custom hook to detect if the page is currently visible and if the window is focused.
 * Useful for detecting tab switching or window/desktop switching.
 */
export const useVisibility = () => {
    const [isVisible, setIsVisible] = useState<boolean>(document.visibilityState === 'visible');
    const [isFocused, setIsFocused] = useState<boolean>(document.hasFocus());

    useEffect(() => {
        const handleVisibilityChange = () => {
            setIsVisible(document.visibilityState === 'visible');
        };

        const handleBlur = () => setIsFocused(false);
        const handleFocus = () => setIsFocused(true);

        document.addEventListener('visibilitychange', handleVisibilityChange);
        window.addEventListener('blur', handleBlur);
        window.addEventListener('focus', handleFocus);

        // Initial check
        setIsVisible(document.visibilityState === 'visible');
        setIsFocused(document.hasFocus());

        return () => {
            document.removeEventListener('visibilitychange', handleVisibilityChange);
            window.removeEventListener('blur', handleBlur);
            window.removeEventListener('focus', handleFocus);
        };
    }, []);

    return { isVisible, isFocused };
};
